export const hi = {
  // Navigation (Hindi)
  explore: 'खोजें',
  search: 'खोज',
  create: 'पोस्ट बनाएं',
  messages: 'संदेश',
  notifications: 'सूचनाएं',
  settings: 'सेटिंग्स',
  profile: 'प्रोफाइल',
  logout: 'लॉग आउट',
  home: 'होम',
  
  // Authentication
  signin: 'साइन इन',
  signup: 'साइन अप',
  login: 'लॉगिन',
  register: 'रजिस्टर',
  email: 'ईमेल',
  password: 'पासवर्ड',
  confirmPassword: 'पासवर्ड की पुष्टि करें',
  firstName: 'पहला नाम',
  lastName: 'अंतिम नाम',
  forgotPassword: 'पासवर्ड भूल गए?',
  alreadyHaveAccount: 'पहले से खाता है? साइन इन करें',
  dontHaveAccount: 'खाता नहीं है? साइन अप करें',
  
  // Posts & Content
  recent: 'हाल ही में',
  trending: 'ट्रेंडिंग',
  popular: 'लोकप्रिय',
  like: 'पसंद',
  likes: 'पसंद',
  comment: 'टिप्पणी',
  comments: 'टिप्पणियां',
  share: 'साझा करें',
  delete: 'हटाएं',
  edit: 'संपादित करें',
  post: 'पोस्ट',
  posts: 'पोस्ट्स',
  title: 'शीर्षक',
  content: 'सामग्री',
  tags: 'टैग्स',
  noBlogsFound: 'कोई ब्लॉग नहीं मिला। कुछ और खोजने की कोशिश करें या पहला बनाएं!',
  
  // AI Assistant
  aiAssistant: 'AI सहायक',
  quickActions: 'त्वरित क्रियाएं',
  writeCaption: 'कैप्शन लिखें',
  suggestTopics: 'विषय सुझाएं',
  improveContent: 'सामग्री में सुधार करें',
  creativeIdeas: 'रचनात्मक विचार',
  clearChat: 'चैट साफ़ करें',
  aiWritingAssistant: 'AI लेखन सहायक',
  poweredByGroq: 'GROQ AI द्वारा संचालित',
  aiGreeting: 'नमस्ते! मैं आपका AI लेखन सहायक हूं। मैं आकर्षक सामग्री बनाने, कैप्शन लिखने, पोस्ट विषय सुझाने और आपके लेखन को बेहतर बनाने में मदद कर सकता हूं। आज आप किस पर काम करना चाहते हैं?',
  askMeToHelp: 'सामग्री, कैप्शन, विषय या लेखन में मदद के लिए पूछें...',
  aiThinking: 'AI सोच रहा है...',
  aiAssistantFunctionalityComingSoon: 'AI सहायक कार्यक्षमता जल्द आ रही है...',
  
  // Chat & Messages
  chat: 'चैट',
  noConversationsYet: 'अभी तक कोई बातचीत नहीं',
  ideafluxChat: 'IdeaFlux चैट',
  typeMessage: 'संदेश टाइप करें...',
  sendMessage: 'संदेश भेजें',
  connectingToChat: 'चैट से कनेक्ट हो रहे हैं...',
  chatFunctionalityComingSoon: 'चैट कार्यक्षमता जल्द आ रही है...',
  
  // Notifications
  noNotificationsYet: 'अभी तक कोई सूचना नहीं।',
  markAllRead: 'सभी को पढ़ा हुआ चिह्नित करें',
  clearAll: 'सभी साफ़ करें',
  notificationsFunctionalityComingSoon: 'सूचना कार्यक्षमता जल्द आ रही है...',
  
  // Settings
  accountSettings: 'खाता सेटिंग्स',
  displayName: 'प्रदर्शन नाम',
  emailAddress: 'ईमेल पता',
  languagePreference: 'भाषा प्राथमिकता',
  privacySecurity: 'गोपनीयता और सुरक्षा',
  notificationPreferences: 'सूचना प्राथमिकताएं',
  allowDirectMessages: 'प्रत्यक्ष संदेशों की अनुमति दें',
  letOthersMessage: 'अन्य उपयोगकर्ताओं को आपको निजी संदेश भेजने दें',
  likesOnPosts: 'पोस्ट पर पसंद',
  commentsOnPosts: 'पोस्ट पर टिप्पणियां',
  newFollowers: 'नए फॉलोअर्स',
  mentions: 'उल्लेख',
  save: 'सेव करें',
  deleteAccount: 'खाता हटाएं',
  
  // Notification descriptions
  getNotifiedWhenSomeone: 'सूचना पाएं जब कोई',
  likesYourPosts: 'आपकी पोस्ट को पसंद करे',
  commentsOnYourPosts: 'आपकी पोस्ट पर टिप्पणी करे',
  followsYou: 'आपको फॉलो करे',
  mentionsYou: 'आपका उल्लेख करे',
  chooseNotifications: 'चुनें कि आप कौन सी सूचनाएं प्राप्त करना चाहते हैं',
  controlWhoInteracts: 'नियंत्रित करें कि कौन आपके साथ बातचीत कर सकता है',
  manageAccountInfo: 'अपनी खाता जानकारी और प्राथमिकताओं का प्रबंधन करें',
  emailCannotBeChanged: 'सुरक्षा कारणों से ईमेल नहीं बदला जा सकता',
  
  // Common
  loading: 'लोड हो रहा है...',
  cancel: 'रद्द करें',
  update: 'अपडेट करें',
  submit: 'जमा करें',
  back: 'वापस',
  next: 'अगला',
  previous: 'पिछला',
  online: 'ऑनलाइन',
  offline: 'ऑफलाइन',
  
  // Profile
  editProfile: 'प्रोफाइल संपादित करें',
  noBioYet: 'अभी तक कोई बायो नहीं।',
  followers: 'फॉलोअर्स',
  following: 'फॉलोइंग',
  recentActivity: 'हाल की गतिविधि',
  noPostsYet: 'अभी तक कोई पोस्ट नहीं',
  shareFirstPost: 'अपनी पहली पोस्ट साझा करें!',
  bio: 'बायो',
  dateOfBirth: 'जन्म तिथि',
  follow: 'फॉलो करें',
  unfollow: 'अनफॉलो करें',
  username: 'यूजरनेम',
  yourPosts: 'आपकी पोस्ट्स',
  
  // Search
  discover: 'खोजें',
  findPeopleStories: 'लोग, कहानियां और विचार खोजें जो आपके लिए महत्वपूर्ण हैं',
  searchByName: 'नाम, शीर्षक या #टैग से खोजें...',
  searchResults: 'खोज परिणाम',
  noResultsFound: 'कोई परिणाम नहीं मिला',
  peopleFound: 'लोग मिले',
  searchFunctionalityComingSoon: 'खोज कार्यक्षमता जल्द आ रही है...',
  
  // Settings - Additional keys
  enterDisplayName: 'अपना प्रदर्शन नाम दर्ज करें',
  saving: 'सेव हो रहा है...',
  confirmDeleteAccount: 'क्या आप वाकई अपना खाता हटाना चाहते हैं? इसे पूर्ववत नहीं किया जा सकता।',
  accountDeletedSuccessfully: 'खाता सफलतापूर्वक हटा दिया गया।',
  errorDeletingAccount: 'खाता हटाने में त्रुटि। कृपया पुनः प्रयास करें।',
  settingsSavedSuccessfully: 'सेटिंग्स सफलतापूर्वक सेव हो गईं!',
  failedToSaveSettings: 'सेटिंग्स सेव करने में विफल। कृपया पुनः प्रयास करें।',
  
  // Form component
  pleaseSignInToCreate: 'पोस्ट बनाने के लिए कृपया साइन इन करें।',
  titleRequired: 'पोस्ट प्रकाशित करने के लिए शीर्षक आवश्यक है।',
  contentRequired: 'पोस्ट प्रकाशित करने के लिए कहानी सामग्री आवश्यक है।',
  contentTooShort: 'कहानी सामग्री कम से कम 10 अक्षर लंबी होनी चाहिए।',
  postUpdatedSuccessfully: 'पोस्ट सफलतापूर्वक अपडेट हो गई!',
  postPublishedSuccessfully: 'पोस्ट सफलतापूर्वक प्रकाशित हो गई!',
  pleaseSignInToCreateBlogs: 'अपने खुद के IdeaFlux ब्लॉग बनाने के लिए कृपया साइन इन करें।',
  enterEngagingTitle: 'एक आकर्षक शीर्षक दर्ज करें...',
  story: 'कहानी',
  writeYourMasterpiece: 'अपनी उत्कृष्ट कृति लिखें...',
  addTags: 'टैग जोड़ें...',
  add: 'जोड़ें',
  publishPost: 'पोस्ट प्रकाशित करें',
  
  // Post component
  linkCopiedToClipboard: 'लिंक क्लिपबोर्ड पर कॉपी हो गया! शेयर काउंट अपडेट हो गया।',
  youAndOthers: 'आप और {{count}} अन्य',
  unknownUser: 'अज्ञात उपयोगकर्ता',
  noImage: 'कोई छवि नहीं',
  deletePost: 'पोस्ट हटाएं',
  confirmDeletePost: 'क्या आप वाकई इस पोस्ट को हटाना चाहते हैं?',
  
  // Email Verification
  verifyEmail: 'ईमेल सत्यापित करें',
  resendCode: 'कोड पुनः भेजें',
};